import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { Button } from '../../../common-components/Button/Button';
import { Field, FieldType } from '../../../common-components/Field/Field';
import { strings } from '../../../resources/strings';
import { StateOrderIdentification } from '../../../enums/StateOrderIdentification';
import { orderStates } from '../../../services/StatesOrders/StatesService';
import { ContainerBody, Row } from './styles';

export enum PendingInvoicingSituationFilter {
  All = 'all',
  Pending = 'pending',
  Ended = 'ended'
}

export enum PendingInvoicingDeliveryFilter {
  All = 'all',
  Express = 'express',
  Carrier = 'carrier'
}

export enum PendingInvoicingOrderSort {
  NewestFirst = 'newest',
  OldestFirst = 'oldest'
}

export interface IFilterToListPendingInvoicingOrdersOutput {
  situation: PendingInvoicingSituationFilter;
  number?: string;
  stateId?: number;
  delivery?: PendingInvoicingDeliveryFilter;
  sort?: PendingInvoicingOrderSort;
}

interface IModalFiltersToListPendingInvoicingOrdersProps {
  appliedFilters: IFilterToListPendingInvoicingOrdersOutput;
  close: () => void;
  finish: (values: IFilterToListPendingInvoicingOrdersOutput) => void;
}

export const situationOptions = [
  { key: PendingInvoicingSituationFilter.Pending, text: 'Pendentes' },
  { key: PendingInvoicingSituationFilter.Ended, text: 'Finalizados' },
  { key: PendingInvoicingSituationFilter.All, text: 'Todos' }
];

// mesmos estados de pendência considerados pelo job (TrackOrderPendingInvoicingService.PendingStateIds no sislog.api)
const pendingInvoicingStateIds: number[] = [
  StateOrderIdentification.PendenteRegistroOmie,
  StateOrderIdentification.PedidoFaturando
];

export const stateOptions = [
  { key: '', text: 'Todos' },
  ...orderStates
    .filter(state => pendingInvoicingStateIds.includes(state.id))
    .map(state => ({ key: `${state.id}`, text: state.name }))
];

export const deliveryOptions = [
  { key: PendingInvoicingDeliveryFilter.All, text: 'Todas' },
  { key: PendingInvoicingDeliveryFilter.Express, text: 'Expressa' },
  { key: PendingInvoicingDeliveryFilter.Carrier, text: 'Transportadora' }
];

export const sortOptions = [
  { key: PendingInvoicingOrderSort.NewestFirst, text: 'Mais recentes primeiro' },
  { key: PendingInvoicingOrderSort.OldestFirst, text: 'Mais antigos primeiro' }
];

const ModalFiltersToListPendingInvoicingOrders: React.FC<IModalFiltersToListPendingInvoicingOrdersProps> = ({
  appliedFilters,
  close,
  finish
}) => {

  const [situation, setSituation] = React.useState<PendingInvoicingSituationFilter>(appliedFilters.situation);
  const [number, setNumber] = React.useState<string | undefined>(appliedFilters.number);
  const [stateId, setStateId] = React.useState<string>(appliedFilters.stateId ? `${appliedFilters.stateId}` : '');
  const [delivery, setDelivery] = React.useState<PendingInvoicingDeliveryFilter>(appliedFilters.delivery || PendingInvoicingDeliveryFilter.All);
  const [sort, setSort] = React.useState<PendingInvoicingOrderSort>(appliedFilters.sort || PendingInvoicingOrderSort.NewestFirst);

  return (
    <Modal
      show={true}
      onHide={() => close()}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header>
        <Modal.Title>
          {`${strings.Filter} ${strings.PendingInvoicingOrders}`}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ maxHeight: '78vh' }}>
        <ContainerBody>
          <Row>
            <Field
              type={FieldType.Text}
              label={'Número do pedido'}
              value={number}
              change={(value) => setNumber(value)}
              autoFocus={true}
              marginTop={'0px'}
              maxLength={20}
            />
          </Row>
          <Row>
            <Field
              type={FieldType.Select}
              label={'Situação'}
              selectProps={{ options: situationOptions, displayField: 'text', keyField: 'key' }}
              value={situation}
              change={(value) => setSituation(value)}
              marginTop={'0px'}
            />
          </Row>
          <Row>
            <Field
              type={FieldType.Select}
              label={'Estado'}
              selectProps={{ options: stateOptions, displayField: 'text', keyField: 'key' }}
              value={stateId}
              change={(value) => setStateId(value)}
              marginTop={'0px'}
            />
          </Row>
          <Row>
            <Field
              type={FieldType.Select}
              label={'Entrega'}
              selectProps={{ options: deliveryOptions, displayField: 'text', keyField: 'key' }}
              value={delivery}
              change={(value) => setDelivery(value)}
              marginTop={'0px'}
            />
          </Row>
          <Row>
            <Field
              type={FieldType.Select}
              label={'Ordem'}
              selectProps={{ options: sortOptions, displayField: 'text', keyField: 'key' }}
              value={sort}
              change={(value) => setSort(value)}
              marginTop={'0px'}
            />
          </Row>
        </ContainerBody>
      </Modal.Body>
      <Modal.Footer>
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Button text={strings.Cancel} click={() => close()} marginRight={'10px'} />
          <Button text={strings.Confirm} click={() => filter()} marginLeft={'10px'} />
        </div>
      </Modal.Footer>
    </Modal>
  );

  function filter() {
    finish({
      situation: situation,
      number: number?.trim() || undefined,
      stateId: stateId ? +stateId : undefined,
      delivery: delivery,
      sort: sort
    });
  }
}

export { ModalFiltersToListPendingInvoicingOrders };
